import actions from './actions'

const initialState = {
  apikeysList: [],
  apikeysAuthList: [],
  apikeysRestList: [],
  apikeysActive: [],
  apikeySearchText: '',
  apikeyQuickStart: 'API_KEY',
  apikeysListTotal: 0,
  apikeysListAuthTotal: 0,
  apikeysListRestTotal: 0,
  apikeysAuthListPagination: {},
  apikeysRestListPagination: {},
  areApikeysLoading: true,
}

export default function apiKeysReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
